import { useTranslation } from 'react-i18next';

import { SectionContainer } from 'components/shared';
import { PalletBalance } from 'interfaces';

import { DamageLossPalletsSummary } from '..';

import styles from './DamagedLostBySupplierPalletsSummarySection.module.css';

type DamagedLostBySupplierPalletsSummarySectionProps = {
   damagedOrLostBySupplierPallets: PalletBalance;
   isSupplierView?: boolean;
   onClickDamagedOrLostBySupplierDetails: () => void;
};

const DamagedLostBySupplierPalletsSummarySection = ({
   damagedOrLostBySupplierPallets,
   isSupplierView,
   onClickDamagedOrLostBySupplierDetails,
}: DamagedLostBySupplierPalletsSummarySectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer
         title={t('damagedLostBySupplierSummary.sectionTitle', {
            context: isSupplierView ? 'supplier' : 'client',
         })}
         subtitle={t('damagedLostByClientSummary.sectionSubtitle')}
         className={styles.container}
      >
         <DamageLossPalletsSummary
            damageLossPalletsSummaryData={damagedOrLostBySupplierPallets}
            onClickDetails={onClickDamagedOrLostBySupplierDetails}
         />
      </SectionContainer>
   );
};

export default DamagedLostBySupplierPalletsSummarySection;
